import React from 'react'
import { Breadcrumb, Row, Col, Calendar, Alert } from 'antd';
import Statistics from './Statistics';
import { DashboardData } from './DashboardData';
import WeekStatics from './WeekStatics';
import {WeekData} from './WeekStatics/WeekData'
import { Grid } from '@material-ui/core';
export const Dashboard=(props)=> {
    return (
        <>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
            </Breadcrumb>

            <Grid container spacing={2}>
                {
                    DashboardData.map((item) => {
                        return <Statistics item={item}></Statistics>
                    })
                }
            </Grid>
            <hr></hr>
            <Grid direction="row-reverse" container spacing={2}>
            <Grid item xs={12} sm={3}>
                    <Row>
                        <h1 > THIS WEEK </h1>
                    </Row>
                    {
                    WeekData.map((item) => {
                        return <WeekStatics  item={item}></WeekStatics>
                    })
                }
                    
                </Grid>
            <Grid style={{zIndex:0}} item xs={12} sm={9}><Alert
                    message={`You selected date`}

                />
                    <div>
                        <Calendar />
                    </div>

                </Grid>
                
            </Grid>



        </>
    )
}

export default Dashboard
